import { AppDispatch, GetAppState, ExtraArgument } from "../store";
import * as alarmGroupActions from "../slices/alarmGroup";
import { UserSpecifier } from "../../types/model";
import { AlarmGroup, Error as APIError } from "../../types/apiv1";

export const getAlarmGroups = () =>
	async (dispatch: AppDispatch, getState: GetAppState, { api }: ExtraArgument) => {
		const state = getState();

		if (!state.session.authenticated)
			throw new Error("can't get alarm groups when not authenticated");

		dispatch(alarmGroupActions.pending());

		let response: AlarmGroup[];
	
		try {
			response = await api.organizations.id(state.session.activeOrganization).alarmgroups.get();
		} catch (e) {
			switch (e) {
			case APIError.Network:
				dispatch(alarmGroupActions.reset(alarmGroupActions.RejectionReason.Network));
				return;
			default:
				dispatch(alarmGroupActions.reset(alarmGroupActions.RejectionReason.Bug));
				return;
			}
		}

		dispatch(alarmGroupActions.ready(response));
	};

export const addAlarmGroupUsers = (alarmGroupID: string, users: UserSpecifier[]) =>
	async (dispatch: AppDispatch, getState: GetAppState, { api }: ExtraArgument) => {
		const state = getState();

		if (!state.session.authenticated)
			throw new Error("can't add user to alarm group when not authenticated");

		const session = state.session;

		const promiseArray = users.map(user =>
			api.organizations.id(session.activeOrganization).alarmgroups.id(alarmGroupID).members.id(user.user_id).put());

		await Promise.all(promiseArray);

		dispatch(getAlarmGroups());
	};

export const removeAlarmGroupUser = (alarmGroupID: string, user: string) =>
	async (dispatch: AppDispatch, getState: GetAppState, { api }: ExtraArgument) => {
		const state = getState();

		if (!state.session.authenticated)
			throw new Error("can't add user to alarm group when not authenticated");

		const session = state.session;

		await api.organizations.id(session.activeOrganization).alarmgroups.id(alarmGroupID).members.id(user).delete();

		dispatch(getAlarmGroups());
	};

